import React, { useState, useEffect, useRef } from 'react'
import { Loader, CheckCircle, XCircle, ExternalLink } from 'lucide-react'
import apiService from '../../services/apiService'
import './AuthFlow.scss'
import authService from '../../services/authService'

const PaymentProcessing = ({
  paymentData,
  // onPaymentSuccess,
  onPaymentSuccessRedirectForLogin,
  onPaymentFailed,
  onLoginSuccess,
}) => {
  const [status, setStatus] = useState('redirecting')
  const [error, setError] = useState('')
  const intervalRef = useRef(null)
  const attemptCount = useRef(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      setStatus('processing')
      window.open(paymentData.redirectUrl, '_blank')
      startVerificationPolling()
    }, 3000)

    return () => {
      clearTimeout(timer)
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  const startVerificationPolling = () => {
    verifyPayment()

    intervalRef.current = setInterval(() => {
      attemptCount.current += 1

      if (attemptCount.current > 192) {
        clearInterval(intervalRef.current)
        setStatus('failed')
        setError('Délai de vérification dépassé (16 minutes)')
        return
      }

      verifyPayment()
    }, 5000)
  }

  const verifyPayment = async () => {
    try {
      const response = await apiService.verifyPayment(paymentData.paymentId)

      if (response.code === 'PAYMENT_PROCESSING') {
        return
      }

      if (response.success && response.data.status === 'completed') {
        clearInterval(intervalRef.current)
        const token = authService.getToken()
        if (token) {
          await apiService.logout(token)
        }
        setStatus('success')
        if (response.data?.token) {
          onLoginSuccess(response.data)
        }

        // const registerResponse = await apiService.completeRegistration(
        //   paymentData.paymentId,
        // )

        // if (registerResponse.success) {
        //   setStatus('success')
        //   setTimeout(() => {
        //     onPaymentSuccess(registerResponse.data)
        //   }, 2000)
        // } else {
        //   setStatus('failed')
        //   setError(
        //     registerResponse.error || 'Erreur lors de la création du compte',
        //   )
        // }
      } else if (
        response.code === 'PAYMENT_FAILED' ||
        response.code === 'PAYMENT_EXPIRED'
      ) {
        clearInterval(intervalRef.current)
        setStatus('failed')
        setError(response.error || 'Paiement échoué')
      }
    } catch (err) {
      console.error('Erreur vérification:', err)
    }
  }

  const handleRetry = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
    attemptCount.current = 0
    onPaymentFailed()
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      <div className='auth-card'>
        {status === 'redirecting' && (
          <div className='payment-status redirecting'>
            <Loader size={48} className='spinning' />
            <h3>Redirection vers la plateforme de paiement...</h3>
            <p>
              Vous allez être redirigé vers{' '}
              {paymentData.method === 'orange_money'
                ? 'Orange Money'
                : 'le portail bancaire'}
            </p>

            <a
              href={paymentData.redirectUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='payment-link'
            >
              <ExternalLink size={16} />
              Ouvrir la page de paiement
            </a>
          </div>
        )}

        {status === 'processing' && (
          <div className='payment-status processing'>
            <Loader size={48} className='spinning' />
            <h3>Vérification du paiement en cours...</h3>
            <p>Veuillez patienter, ne fermez pas cette fenêtre</p>
            <p
              style={{
                margin: '10px, 0px',
                fontSize: '14px',
                color: '#d97706',
              }}
            >
              Cliquez sur le bouton ci-dessous si vous n’êtes pas redirigé vers{' '}
              {paymentData.method === 'orange_money'
                ? 'Orange Money'
                : 'le portail bancaire'}
            </p>
            <a
              href={paymentData.redirectUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='payment-link'
            >
              <ExternalLink size={16} />
              Ouvrir la page de paiement
            </a>
          </div>
        )}

        {status === 'success' && (
          <div className='payment-status success'>
            <CheckCircle size={64} className='success-icon' />
            <h3>Paiement réussi !</h3>
            <p>Votre paiement a été effectué avec succès.</p>

            <button
              onClick={() => onPaymentSuccessRedirectForLogin()}
              className='redirect-login-link'
            >
              <ExternalLink size={16} />
              Se connecter maintenant
            </button>
          </div>
        )}

        {status === 'failed' && (
          <div className='payment-status failed'>
            <XCircle size={64} className='error-icon' />
            <h3>Paiement échoué</h3>
            <p className='error-message'>{error}</p>
            <button onClick={handleRetry} className='btn primary lg full'>
              Réessayer
            </button>
          </div>
        )}

        {/* {status === 'error-get-linkPayement' && (
          <div className='payment-status failed'>
            <XCircle size={64} className='error-icon' />
            <h3>Erreur de redirection </h3>
            <p className='error-message'>
              Vueillez réessayer s'il vous plait, et si l'erreur persiste, merci
              de nous contacter sur WhatsApp au +224610101010.
            </p>
            <button onClick={handleRetry} className='btn primary lg full'>
              Réessayer
            </button>
          </div>
        )} */}
      </div>

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default PaymentProcessing
